import config from '@/config/config';

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}
/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
  routerBack 是否显示返回按钮
*/

const visitorMode = Boolean(process.env.VUE_APP_VISITOR_MODE)

const routeMap = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/user/Login/index.vue'),
    meta: {
      name: '登录',
      noLogin: config.visitorMode,
      routerBack: false
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/user/Register'),
    meta: { name: '注册', noLogin: config.visitorMode }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search/index.vue'),
    meta: { name: '搜索', noLogin: config.visitorMode }
  },
  {
    path: '/location',
    name: 'location',
    component: () => import('@/views/location'),
    meta: { name: '位置' }
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('@/views/product'),
    meta: { name: '商品', noLogin: config.visitorMode }
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('@/views/order/orderList'),
    meta: { name: '订单' }
  },
  {
    path: '/orderInfo',
    name: 'orderInfo',
    component: () => import('@/views/order/orderDetail'),
    meta: { name: '订单详情' }
  },
  {
    path: '/myaddress',
    name: 'Myaddress',
    component: () => import('@/views/address/addressList'),
    meta: { name: '我的地址' }
  },
  {
    path: '/editaddress',
    name: 'editaddress',
    component: () =>
      import('@/views/address/addressDetail'),
    meta: { name: '修改地址' }
  },
  {
    path: '/orderhistory',
    name: 'orderhistory',
    component: () => import('@/views/order/orderHistory'),
    meta: { name: '订单记录' }
  },
  {
    path: '/service',
    name: 'service',
    redirect: '/sceneval',
    component: () => import('@/views/service'),
    children: [
      {
        path: '/sceneval',
        name: 'sceneval',
        component: () =>
          import('@/views/service/children/sceneval'),
        meta: { name: '售后服务' }
      }
    ],
    meta: { tabShow: true }
  },
  {
    path: '/userinfo',
    name: 'userInfo',
    component: () => import('@/views/userInfo'),
    meta: { name: '个人信息' }
  },
  // {
  // 	path: '/resetpassword',
  // 	name: 'resetPassword',
  // 	component: () => import('@/views/user/resetPassword'),
  // 	meta: { name: '忘记密码' },
  // },
  {
    path: '/welfare',
    name: 'welfare',
    component: () => import('@/views/welfare'),
    meta: { name: '我的福利' }
  },
  {
    path: '/prodetail',
    name: 'prodetail',
    component: () => import('@/views/prodetail'),
    meta: { name: '商品详情', noLogin: config.visitorMode }
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/payment'),
    meta: { name: '确认订单' }
  },
  {
    path: '/paymentCashier',
    name: 'paymentCashier',
    component: () => import('@/views/paymentCashier'),
    meta: { name: '收银柜' }
  },
  // {
  //   path: '/mydiylist',
  //   name: 'myDiyList',
  //   component: () =>
  //     import('@/views/giftDiy/component/myDiyList'),
  //   meta: { name: '我的DIY' }
  // },
  {
    path: '/logistic',
    name: 'logistic',
    component: () => import('@/views/logistic'),
    meta: { name: '商品物流' }
  },
  // {
  //   path: '/makingCard',
  //   name: 'makingCard',
  //   component: () =>
  //     import('@/views/giftDiy/component/makingCard'),
  //   meta: { name: '个性定制' }
  // },
  {
    path: '/payOrderStatus',
    name: 'payOrderStatus',
    component: () => import('@/views/payOrderStatus')
  },
  {
    path: '/UserInfoHandle',
    name: 'UserInfoHandle',
    component: () => import('@/views/UserInfoHandle')
  },
  {
    path: '/bindTel',
    name: 'bindTel',
    component: () => import('@/views/bindTel')
  },
  {
    path: '/payment2',
    name: 'payment2',
    component: () => import('@/views/payment2')
  },
  {
    path: '/flash-sale',
    name: 'FlashSale',
    component: () => import('@/views/flashSale'),
    meta: { name: '限时抢购' }
  },
  {
    path: '/special-offer',
    name: 'SpecialOffer',
    component: () => import('@/views/specialOffer'),
    meta: { name: '特惠活动' }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import('@/views/wallet'),
    meta: { name: '我的钱包' }
  },
  {
    path: '/conpon',
    name: 'Conpon',
    redirect: '/conpon/list',
    component: RouteView,
    children: [
      {
        path: '/conpon/list',
        name: 'ConponList',
        component: () => import('@/views/conpon/conponList')
      },
      {
        path: '/conpon/detail',
        name: 'ConponDetail',
        component: () =>
          import('@/views/conpon/conponDetail')
      }
    ]
  },
  {
    path: '/myRecord',
    name: 'MyRecord',
    component: () => import('@/views/myRecord'),
    meta: { name: '我的足迹' }
  },
  {
    path: '/gitf',
    name: 'Gift',
    component: () => import('@/views/gift'),
    mete: { name: '礼包' }
  },
  {
    path: '/catering',
    name: 'Catering',
    component: () => import('@/views/catering'),
    meta: { name: '餐饮汇聚' }
  },
  {
    path: '/paymentPlatform',
    name: 'PaymentPlatform',
    component: () => import('@/views/paymentPlatform'),
    meta: { name: '支付平台' }
  },
  {
    path: '/mallModel',
    name: 'MallModel',
    component: () => import('@/views/mallModel'),
    meta: { name: '商城模板' }
  }
]

export default routeMap;
